import { UploadedFile } from '../shared-components/file-upload/types';
import { apiBaseUrl } from '../config';

export const buildDownloadUrl = (file: UploadedFile) =>
  `${apiBaseUrl}/download?token=${file.fileToken}&fileId=${file.id}`;
